import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CookieConsent = () => {
  const { i18n } = useTranslation();
  const isHindi = i18n.language === 'hi';
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] bg-[#1A1A1A] border-t border-[#C9A84C]/20 px-6 py-4 shadow-lg" data-testid="cookie-consent">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-[#A3A3A3] text-sm">
          {isHindi
            ? 'हम आपके अनुभव को बेहतर बनाने के लिए कुकीज़ का उपयोग करते हैं। साइट का उपयोग जारी रखकर, आप हमारी कुकी नीति से सहमत होते हैं।'
            : 'We use cookies to improve your experience. By continuing to use this site, you agree to our cookie policy.'}
        </p>
        <button onClick={accept}
          className="bg-[#C9A84C] text-[#0A0A0A] px-6 py-2 text-sm font-medium hover:bg-[#E5C870] transition-colors whitespace-nowrap uppercase tracking-wider"
          data-testid="cookie-accept-btn">
          {isHindi ? 'स्वीकार करें' : 'Accept'}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
